import React from 'react';
import Sidebar from '../../Navigation/Sidebar/Sidebar';
import leftArrow from "../../../assests/leftArrow.svg"
import { Button } from "@mui/material";
import LoadingSpinner from "../../Loading/component";   // ✅ import spinner
import './productExpiry.css';

const Product_Expiry_Component = ({
  products,
  loading,
  error,
  searchTerm,
  setSearchTerm,
  navigate,
  formatCurrency,
  hasMore,
  onLoadNextPage,
  currentPage
}) => {

  const handleProductNameClick = (id) => {
    navigate(`/home/configuration/productlist/details/${id}`);
  };

  return (
    <div className="product-expiry-container">


      {/* ✅ Full page loader overlay */}
      {loading && (
        <div className="full-page-loader">
          <LoadingSpinner />
        </div>
      )}
      <Sidebar />
      <div className="product-expiry-content">
        <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
          <Button
            className="back-button"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <img src={leftArrow} alt="" />
          </Button>
          <h1>Product List</h1>
        </div>

        <div className="producct-list-search-container">
          <input
            type="text"
            placeholder="Search Product By Name Or MVID"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-input"
          />
        </div>

        <div className="product-expiry-table-container">
          <table className="product-table">
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Image</th>
                <th>MVID</th>
                <th>Product Name</th>
                <th>Meal Type</th>
                <th>Vendor</th>
                <th>Vendor Price</th>
                <th>MRP</th>
                <th>Offer Price</th>
              </tr>
            </thead>
            <tbody>
              {products.length > 0 ? (
                products.map((product, index) => (
                  <tr key={product.id || index}>
                    <td>{index + 1}</td>
                    <td className="image-cell">
                      {product.image_id ? (
                        <img
                          src={`https://s3.ap-south-1.amazonaws.com/daalchini/dcprod/${product.image_id}`}
                          alt={product.variant_name}
                          className="product-expiry-image"
                          onError={(e) => {
                            e.target.style.display = 'none';
                            if (e.target.nextSibling) {
                              e.target.nextSibling.style.display = 'block';
                            }
                          }}
                        />
                      ) : null}
                      <div className="product-image-placeholder"></div>
                    </td>
                    <td>{product.id || 'N/A'}</td>
                    <td>
                      <span
                        className="product-name-link"
                        onClick={() => handleProductNameClick(product.id)}
                      >
                        {product.variant_name || 'N/A'}
                      </span>
                    </td>
                    <td>
                      <span>{product.meal_type || 'N/A'}</span>
                    </td>
                    <td>{product.manufacturer_name || 'N/A'}</td>
                    <td className="price-cell">{formatCurrency(product.vendor_price)}</td>
                    <td className="price-cell">{formatCurrency(product.mrp)}</td>
                    <td className="price-cell">{formatCurrency(product.offer_price)}</td>
                  </tr>
                ))
              ) : (
                !loading && (
                  <tr>
                    <td colSpan="9" className="no-data">
                      No products found
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </table>

          {hasMore && products.length > 0 && (
            <div className="load-more-container">
              <Button
                variant="outlined"
                onClick={onLoadNextPage}
                disabled={loading}
              >
                {loading ? 'Loading...' : 'Load More'}
              </Button>
            </div>
          )}

         
        </div>
      </div>
    </div>
  );
};

export default Product_Expiry_Component;
